export default {"src":"/_next/static/media/wagered.426bcb06.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};